// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PrivateSchemaTypes from '../../../../../graphql/private/PrivateSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type ResendInvitationEmailMutationVariables = PrivateSchemaTypes.Exact<{
  eventId: PrivateSchemaTypes.Scalars['PositiveInt'];
  userId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type ResendInvitationEmailMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { event?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'EventModelAsAdmin' }
      & Pick<PrivateSchemaTypes.EventModelAsAdmin, 'id'>
      & { invitee?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'UserEventModelWithSource' }
        & Pick<PrivateSchemaTypes.UserEventModelWithSource, 'resendInvitationEmail'>
      )> }
    )> }
  )> }
);

export type ResendInvitationEmailEventSeriesMutationVariables = PrivateSchemaTypes.Exact<{
  eventId: PrivateSchemaTypes.Scalars['PositiveInt'];
  userId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type ResendInvitationEmailEventSeriesMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { recurringEvent?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'RecurringEventModelAsAdmin' }
      & Pick<PrivateSchemaTypes.RecurringEventModelAsAdmin, 'id'>
      & { invitee?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'RecurringEventInviteeModel' }
        & Pick<PrivateSchemaTypes.RecurringEventInviteeModel, 'resendInvitationEmail'>
      )> }
    )> }
  )> }
);

export type SetEventInviteePresentFlagMutationVariables = PrivateSchemaTypes.Exact<{
  eventId: PrivateSchemaTypes.Scalars['PositiveInt'];
  userId: PrivateSchemaTypes.Scalars['PositiveInt'];
  present?: PrivateSchemaTypes.Maybe<PrivateSchemaTypes.Scalars['Boolean']>;
  groupId?: PrivateSchemaTypes.Maybe<PrivateSchemaTypes.Scalars['PositiveInt']>;
}>;


export type SetEventInviteePresentFlagMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { event?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'EventModelAsAdmin' }
      & Pick<PrivateSchemaTypes.EventModelAsAdmin, 'id'>
      & { inviteeWithUpsert?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'UserEventModel' }
        & { patch?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'UserEventModel' }
          & Pick<PrivateSchemaTypes.UserEventModel, 'present'>
        )> }
      )> }
    )> }
  )> }
);

export type SetEventInviteePresentFlagEventSeriesMutationVariables = PrivateSchemaTypes.Exact<{
  eventId: PrivateSchemaTypes.Scalars['PositiveInt'];
  userId: PrivateSchemaTypes.Scalars['PositiveInt'];
  present?: PrivateSchemaTypes.Maybe<PrivateSchemaTypes.Scalars['Boolean']>;
  groupId?: PrivateSchemaTypes.Maybe<PrivateSchemaTypes.Scalars['PositiveInt']>;
}>;


export type SetEventInviteePresentFlagEventSeriesMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { recurringEvent?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'RecurringEventModelAsAdmin' }
      & Pick<PrivateSchemaTypes.RecurringEventModelAsAdmin, 'id'>
      & { inviteeWithInsert?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'RecurringEventInviteeModel' }
        & { patch?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'RecurringEventInviteeModel' }
          & Pick<PrivateSchemaTypes.RecurringEventInviteeModel, 'present'>
        )> }
      )> }
    )> }
  )> }
);

export type SetEventInviteeAttendanceFlagMutationVariables = PrivateSchemaTypes.Exact<{
  eventId: PrivateSchemaTypes.Scalars['PositiveInt'];
  userId: PrivateSchemaTypes.Scalars['PositiveInt'];
  attending?: PrivateSchemaTypes.Maybe<PrivateSchemaTypes.Scalars['Boolean']>;
  groupId?: PrivateSchemaTypes.Maybe<PrivateSchemaTypes.Scalars['PositiveInt']>;
}>;


export type SetEventInviteeAttendanceFlagMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { event?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'EventModelAsAdmin' }
      & Pick<PrivateSchemaTypes.EventModelAsAdmin, 'id'>
      & { inviteeWithUpsert?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'UserEventModel' }
        & { patch?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'UserEventModel' }
          & Pick<PrivateSchemaTypes.UserEventModel, 'attending'>
        )> }
      )> }
    )> }
  )> }
);

export type SetEventInviteeAttendanceFlagEventSeriesMutationVariables = PrivateSchemaTypes.Exact<{
  eventId: PrivateSchemaTypes.Scalars['PositiveInt'];
  userId: PrivateSchemaTypes.Scalars['PositiveInt'];
  attending?: PrivateSchemaTypes.Maybe<PrivateSchemaTypes.Scalars['Boolean']>;
  groupId?: PrivateSchemaTypes.Maybe<PrivateSchemaTypes.Scalars['PositiveInt']>;
}>;


export type SetEventInviteeAttendanceFlagEventSeriesMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { recurringEvent?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'RecurringEventModelAsAdmin' }
      & Pick<PrivateSchemaTypes.RecurringEventModelAsAdmin, 'id'>
      & { inviteeWithInsert?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'RecurringEventInviteeModel' }
        & { patch?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'RecurringEventInviteeModel' }
          & Pick<PrivateSchemaTypes.RecurringEventInviteeModel, 'attending'>
        )> }
      )> }
    )> }
  )> }
);

export type RemoveInviteeMutationVariables = PrivateSchemaTypes.Exact<{
  eventId: PrivateSchemaTypes.Scalars['PositiveInt'];
  userId: PrivateSchemaTypes.Scalars['PositiveInt'];
  sendCancellationEmail: PrivateSchemaTypes.Scalars['Boolean'];
}>;


export type RemoveInviteeMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { event?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'EventModelAsAdmin' }
      & Pick<PrivateSchemaTypes.EventModelAsAdmin, 'id' | 'removeInvitee'>
    )> }
  )> }
);

export type RemoveInviteeFromSeriesMutationVariables = PrivateSchemaTypes.Exact<{
  eventId: PrivateSchemaTypes.Scalars['PositiveInt'];
  userId: PrivateSchemaTypes.Scalars['PositiveInt'];
  sendCancellationEmail: PrivateSchemaTypes.Scalars['Boolean'];
}>;


export type RemoveInviteeFromSeriesMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { recurringEvent?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'RecurringEventModelAsAdmin' }
      & Pick<PrivateSchemaTypes.RecurringEventModelAsAdmin, 'id' | 'removeInvitee'>
    )> }
  )> }
);

export type SyncAttendeesStatusWith3dPartyCalendarsQueryVariables = PrivateSchemaTypes.Exact<{
  eventId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type SyncAttendeesStatusWith3dPartyCalendarsQuery = (
  { __typename?: 'Query' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerQueries' }
    & { event?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'EventModelAsAdmin' }
      & Pick<PrivateSchemaTypes.EventModelAsAdmin, 'syncAttendeesStatusWith3dPartyCalendars'>
    )> }
  )> }
);

export type RemoveAttendeesFrom3dPartyCalendarsQueryVariables = PrivateSchemaTypes.Exact<{
  eventId: PrivateSchemaTypes.Scalars['PositiveInt'];
  emails: Array<PrivateSchemaTypes.Scalars['String']> | PrivateSchemaTypes.Scalars['String'];
}>;


export type RemoveAttendeesFrom3dPartyCalendarsQuery = (
  { __typename?: 'Query' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerQueries' }
    & { event?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'EventModelAsAdmin' }
      & Pick<PrivateSchemaTypes.EventModelAsAdmin, 'removeAttendeesFrom3dPartyCalendars'>
    )> }
  )> }
);

export type RemoveAttendeesFrom3dPartyCalendarsEventSeriesQueryVariables = PrivateSchemaTypes.Exact<{
  eventId: PrivateSchemaTypes.Scalars['PositiveInt'];
  emails: Array<PrivateSchemaTypes.Scalars['String']> | PrivateSchemaTypes.Scalars['String'];
}>;


export type RemoveAttendeesFrom3dPartyCalendarsEventSeriesQuery = (
  { __typename?: 'Query' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerQueries' }
    & { recurringEvent?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'RecurringEventModelAsAdmin' }
      & Pick<PrivateSchemaTypes.RecurringEventModelAsAdmin, 'removeAttendeesFrom3dPartyCalendars'>
    )> }
  )> }
);


export const ResendInvitationEmailDocument = gql`
    mutation resendInvitationEmail($eventId: PositiveInt!, $userId: PositiveInt!) {
  admin {
    event(id: $eventId) {
      id
      invitee(userId: $userId) {
        resendInvitationEmail
      }
    }
  }
}
    `;
export type ResendInvitationEmailMutationFn = Apollo.MutationFunction<ResendInvitationEmailMutation, ResendInvitationEmailMutationVariables>;

/**
 * __useResendInvitationEmailMutation__
 *
 * To run a mutation, you first call `useResendInvitationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendInvitationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendInvitationEmailMutation, { data, loading, error }] = useResendInvitationEmailMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useResendInvitationEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResendInvitationEmailMutation, ResendInvitationEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ResendInvitationEmailMutation, ResendInvitationEmailMutationVariables>(ResendInvitationEmailDocument, options);
      }
export type ResendInvitationEmailMutationHookResult = ReturnType<typeof useResendInvitationEmailMutation>;
export type ResendInvitationEmailMutationResult = Apollo.MutationResult<ResendInvitationEmailMutation>;
export type ResendInvitationEmailMutationOptions = Apollo.BaseMutationOptions<ResendInvitationEmailMutation, ResendInvitationEmailMutationVariables>;
export const ResendInvitationEmailEventSeriesDocument = gql`
    mutation resendInvitationEmailEventSeries($eventId: PositiveInt!, $userId: PositiveInt!) {
  admin {
    recurringEvent(id: $eventId) {
      id
      invitee(userId: $userId) {
        resendInvitationEmail
      }
    }
  }
}
    `;
export type ResendInvitationEmailEventSeriesMutationFn = Apollo.MutationFunction<ResendInvitationEmailEventSeriesMutation, ResendInvitationEmailEventSeriesMutationVariables>;

/**
 * __useResendInvitationEmailEventSeriesMutation__
 *
 * To run a mutation, you first call `useResendInvitationEmailEventSeriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendInvitationEmailEventSeriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendInvitationEmailEventSeriesMutation, { data, loading, error }] = useResendInvitationEmailEventSeriesMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useResendInvitationEmailEventSeriesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResendInvitationEmailEventSeriesMutation, ResendInvitationEmailEventSeriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ResendInvitationEmailEventSeriesMutation, ResendInvitationEmailEventSeriesMutationVariables>(ResendInvitationEmailEventSeriesDocument, options);
      }
export type ResendInvitationEmailEventSeriesMutationHookResult = ReturnType<typeof useResendInvitationEmailEventSeriesMutation>;
export type ResendInvitationEmailEventSeriesMutationResult = Apollo.MutationResult<ResendInvitationEmailEventSeriesMutation>;
export type ResendInvitationEmailEventSeriesMutationOptions = Apollo.BaseMutationOptions<ResendInvitationEmailEventSeriesMutation, ResendInvitationEmailEventSeriesMutationVariables>;
export const SetEventInviteePresentFlagDocument = gql`
    mutation setEventInviteePresentFlag($eventId: PositiveInt!, $userId: PositiveInt!, $present: Boolean, $groupId: PositiveInt) {
  admin {
    event(id: $eventId) {
      id
      inviteeWithUpsert(userId: $userId, groupId: $groupId) {
        patch(present: $present) {
          present
        }
      }
    }
  }
}
    `;
export type SetEventInviteePresentFlagMutationFn = Apollo.MutationFunction<SetEventInviteePresentFlagMutation, SetEventInviteePresentFlagMutationVariables>;

/**
 * __useSetEventInviteePresentFlagMutation__
 *
 * To run a mutation, you first call `useSetEventInviteePresentFlagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetEventInviteePresentFlagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setEventInviteePresentFlagMutation, { data, loading, error }] = useSetEventInviteePresentFlagMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      userId: // value for 'userId'
 *      present: // value for 'present'
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useSetEventInviteePresentFlagMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetEventInviteePresentFlagMutation, SetEventInviteePresentFlagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetEventInviteePresentFlagMutation, SetEventInviteePresentFlagMutationVariables>(SetEventInviteePresentFlagDocument, options);
      }
export type SetEventInviteePresentFlagMutationHookResult = ReturnType<typeof useSetEventInviteePresentFlagMutation>;
export type SetEventInviteePresentFlagMutationResult = Apollo.MutationResult<SetEventInviteePresentFlagMutation>;
export type SetEventInviteePresentFlagMutationOptions = Apollo.BaseMutationOptions<SetEventInviteePresentFlagMutation, SetEventInviteePresentFlagMutationVariables>;
export const SetEventInviteePresentFlagEventSeriesDocument = gql`
    mutation setEventInviteePresentFlagEventSeries($eventId: PositiveInt!, $userId: PositiveInt!, $present: Boolean, $groupId: PositiveInt) {
  admin {
    recurringEvent(id: $eventId) {
      id
      inviteeWithInsert(userId: $userId, groupId: $groupId) {
        patch(present: $present) {
          present
        }
      }
    }
  }
}
    `;
export type SetEventInviteePresentFlagEventSeriesMutationFn = Apollo.MutationFunction<SetEventInviteePresentFlagEventSeriesMutation, SetEventInviteePresentFlagEventSeriesMutationVariables>;

/**
 * __useSetEventInviteePresentFlagEventSeriesMutation__
 *
 * To run a mutation, you first call `useSetEventInviteePresentFlagEventSeriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetEventInviteePresentFlagEventSeriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setEventInviteePresentFlagEventSeriesMutation, { data, loading, error }] = useSetEventInviteePresentFlagEventSeriesMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      userId: // value for 'userId'
 *      present: // value for 'present'
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useSetEventInviteePresentFlagEventSeriesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetEventInviteePresentFlagEventSeriesMutation, SetEventInviteePresentFlagEventSeriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetEventInviteePresentFlagEventSeriesMutation, SetEventInviteePresentFlagEventSeriesMutationVariables>(SetEventInviteePresentFlagEventSeriesDocument, options);
      }
export type SetEventInviteePresentFlagEventSeriesMutationHookResult = ReturnType<typeof useSetEventInviteePresentFlagEventSeriesMutation>;
export type SetEventInviteePresentFlagEventSeriesMutationResult = Apollo.MutationResult<SetEventInviteePresentFlagEventSeriesMutation>;
export type SetEventInviteePresentFlagEventSeriesMutationOptions = Apollo.BaseMutationOptions<SetEventInviteePresentFlagEventSeriesMutation, SetEventInviteePresentFlagEventSeriesMutationVariables>;
export const SetEventInviteeAttendanceFlagDocument = gql`
    mutation setEventInviteeAttendanceFlag($eventId: PositiveInt!, $userId: PositiveInt!, $attending: Boolean, $groupId: PositiveInt) {
  admin {
    event(id: $eventId) {
      id
      inviteeWithUpsert(userId: $userId, groupId: $groupId) {
        patch(attending: $attending) {
          attending
        }
      }
    }
  }
}
    `;
export type SetEventInviteeAttendanceFlagMutationFn = Apollo.MutationFunction<SetEventInviteeAttendanceFlagMutation, SetEventInviteeAttendanceFlagMutationVariables>;

/**
 * __useSetEventInviteeAttendanceFlagMutation__
 *
 * To run a mutation, you first call `useSetEventInviteeAttendanceFlagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetEventInviteeAttendanceFlagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setEventInviteeAttendanceFlagMutation, { data, loading, error }] = useSetEventInviteeAttendanceFlagMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      userId: // value for 'userId'
 *      attending: // value for 'attending'
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useSetEventInviteeAttendanceFlagMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetEventInviteeAttendanceFlagMutation, SetEventInviteeAttendanceFlagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetEventInviteeAttendanceFlagMutation, SetEventInviteeAttendanceFlagMutationVariables>(SetEventInviteeAttendanceFlagDocument, options);
      }
export type SetEventInviteeAttendanceFlagMutationHookResult = ReturnType<typeof useSetEventInviteeAttendanceFlagMutation>;
export type SetEventInviteeAttendanceFlagMutationResult = Apollo.MutationResult<SetEventInviteeAttendanceFlagMutation>;
export type SetEventInviteeAttendanceFlagMutationOptions = Apollo.BaseMutationOptions<SetEventInviteeAttendanceFlagMutation, SetEventInviteeAttendanceFlagMutationVariables>;
export const SetEventInviteeAttendanceFlagEventSeriesDocument = gql`
    mutation setEventInviteeAttendanceFlagEventSeries($eventId: PositiveInt!, $userId: PositiveInt!, $attending: Boolean, $groupId: PositiveInt) {
  admin {
    recurringEvent(id: $eventId) {
      id
      inviteeWithInsert(userId: $userId, groupId: $groupId) {
        patch(attending: $attending) {
          attending
        }
      }
    }
  }
}
    `;
export type SetEventInviteeAttendanceFlagEventSeriesMutationFn = Apollo.MutationFunction<SetEventInviteeAttendanceFlagEventSeriesMutation, SetEventInviteeAttendanceFlagEventSeriesMutationVariables>;

/**
 * __useSetEventInviteeAttendanceFlagEventSeriesMutation__
 *
 * To run a mutation, you first call `useSetEventInviteeAttendanceFlagEventSeriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetEventInviteeAttendanceFlagEventSeriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setEventInviteeAttendanceFlagEventSeriesMutation, { data, loading, error }] = useSetEventInviteeAttendanceFlagEventSeriesMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      userId: // value for 'userId'
 *      attending: // value for 'attending'
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useSetEventInviteeAttendanceFlagEventSeriesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetEventInviteeAttendanceFlagEventSeriesMutation, SetEventInviteeAttendanceFlagEventSeriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetEventInviteeAttendanceFlagEventSeriesMutation, SetEventInviteeAttendanceFlagEventSeriesMutationVariables>(SetEventInviteeAttendanceFlagEventSeriesDocument, options);
      }
export type SetEventInviteeAttendanceFlagEventSeriesMutationHookResult = ReturnType<typeof useSetEventInviteeAttendanceFlagEventSeriesMutation>;
export type SetEventInviteeAttendanceFlagEventSeriesMutationResult = Apollo.MutationResult<SetEventInviteeAttendanceFlagEventSeriesMutation>;
export type SetEventInviteeAttendanceFlagEventSeriesMutationOptions = Apollo.BaseMutationOptions<SetEventInviteeAttendanceFlagEventSeriesMutation, SetEventInviteeAttendanceFlagEventSeriesMutationVariables>;
export const RemoveInviteeDocument = gql`
    mutation removeInvitee($eventId: PositiveInt!, $userId: PositiveInt!, $sendCancellationEmail: Boolean!) {
  admin {
    event(id: $eventId) {
      id
      removeInvitee(userId: $userId, sendCancellationEmail: $sendCancellationEmail)
    }
  }
}
    `;
export type RemoveInviteeMutationFn = Apollo.MutationFunction<RemoveInviteeMutation, RemoveInviteeMutationVariables>;

/**
 * __useRemoveInviteeMutation__
 *
 * To run a mutation, you first call `useRemoveInviteeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveInviteeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeInviteeMutation, { data, loading, error }] = useRemoveInviteeMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      userId: // value for 'userId'
 *      sendCancellationEmail: // value for 'sendCancellationEmail'
 *   },
 * });
 */
export function useRemoveInviteeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveInviteeMutation, RemoveInviteeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveInviteeMutation, RemoveInviteeMutationVariables>(RemoveInviteeDocument, options);
      }
export type RemoveInviteeMutationHookResult = ReturnType<typeof useRemoveInviteeMutation>;
export type RemoveInviteeMutationResult = Apollo.MutationResult<RemoveInviteeMutation>;
export type RemoveInviteeMutationOptions = Apollo.BaseMutationOptions<RemoveInviteeMutation, RemoveInviteeMutationVariables>;
export const RemoveInviteeFromSeriesDocument = gql`
    mutation removeInviteeFromSeries($eventId: PositiveInt!, $userId: PositiveInt!, $sendCancellationEmail: Boolean!) {
  admin {
    recurringEvent(id: $eventId) {
      id
      removeInvitee(userId: $userId, sendCancellationEmail: $sendCancellationEmail)
    }
  }
}
    `;
export type RemoveInviteeFromSeriesMutationFn = Apollo.MutationFunction<RemoveInviteeFromSeriesMutation, RemoveInviteeFromSeriesMutationVariables>;

/**
 * __useRemoveInviteeFromSeriesMutation__
 *
 * To run a mutation, you first call `useRemoveInviteeFromSeriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveInviteeFromSeriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeInviteeFromSeriesMutation, { data, loading, error }] = useRemoveInviteeFromSeriesMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      userId: // value for 'userId'
 *      sendCancellationEmail: // value for 'sendCancellationEmail'
 *   },
 * });
 */
export function useRemoveInviteeFromSeriesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveInviteeFromSeriesMutation, RemoveInviteeFromSeriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveInviteeFromSeriesMutation, RemoveInviteeFromSeriesMutationVariables>(RemoveInviteeFromSeriesDocument, options);
      }
export type RemoveInviteeFromSeriesMutationHookResult = ReturnType<typeof useRemoveInviteeFromSeriesMutation>;
export type RemoveInviteeFromSeriesMutationResult = Apollo.MutationResult<RemoveInviteeFromSeriesMutation>;
export type RemoveInviteeFromSeriesMutationOptions = Apollo.BaseMutationOptions<RemoveInviteeFromSeriesMutation, RemoveInviteeFromSeriesMutationVariables>;
export const SyncAttendeesStatusWith3dPartyCalendarsDocument = gql`
    query syncAttendeesStatusWith3dPartyCalendars($eventId: PositiveInt!) {
  admin {
    event(id: $eventId) {
      syncAttendeesStatusWith3dPartyCalendars
    }
  }
}
    `;

/**
 * __useSyncAttendeesStatusWith3dPartyCalendarsQuery__
 *
 * To run a query within a React component, call `useSyncAttendeesStatusWith3dPartyCalendarsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSyncAttendeesStatusWith3dPartyCalendarsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSyncAttendeesStatusWith3dPartyCalendarsQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useSyncAttendeesStatusWith3dPartyCalendarsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SyncAttendeesStatusWith3dPartyCalendarsQuery, SyncAttendeesStatusWith3dPartyCalendarsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SyncAttendeesStatusWith3dPartyCalendarsQuery, SyncAttendeesStatusWith3dPartyCalendarsQueryVariables>(SyncAttendeesStatusWith3dPartyCalendarsDocument, options);
      }
export function useSyncAttendeesStatusWith3dPartyCalendarsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SyncAttendeesStatusWith3dPartyCalendarsQuery, SyncAttendeesStatusWith3dPartyCalendarsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SyncAttendeesStatusWith3dPartyCalendarsQuery, SyncAttendeesStatusWith3dPartyCalendarsQueryVariables>(SyncAttendeesStatusWith3dPartyCalendarsDocument, options);
        }
export type SyncAttendeesStatusWith3dPartyCalendarsQueryHookResult = ReturnType<typeof useSyncAttendeesStatusWith3dPartyCalendarsQuery>;
export type SyncAttendeesStatusWith3dPartyCalendarsLazyQueryHookResult = ReturnType<typeof useSyncAttendeesStatusWith3dPartyCalendarsLazyQuery>;
export type SyncAttendeesStatusWith3dPartyCalendarsQueryResult = Apollo.QueryResult<SyncAttendeesStatusWith3dPartyCalendarsQuery, SyncAttendeesStatusWith3dPartyCalendarsQueryVariables>;
export const RemoveAttendeesFrom3dPartyCalendarsDocument = gql`
    query removeAttendeesFrom3dPartyCalendars($eventId: PositiveInt!, $emails: [String!]!) {
  admin {
    event(id: $eventId) {
      removeAttendeesFrom3dPartyCalendars(emails: $emails)
    }
  }
}
    `;

/**
 * __useRemoveAttendeesFrom3dPartyCalendarsQuery__
 *
 * To run a query within a React component, call `useRemoveAttendeesFrom3dPartyCalendarsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRemoveAttendeesFrom3dPartyCalendarsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRemoveAttendeesFrom3dPartyCalendarsQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      emails: // value for 'emails'
 *   },
 * });
 */
export function useRemoveAttendeesFrom3dPartyCalendarsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RemoveAttendeesFrom3dPartyCalendarsQuery, RemoveAttendeesFrom3dPartyCalendarsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RemoveAttendeesFrom3dPartyCalendarsQuery, RemoveAttendeesFrom3dPartyCalendarsQueryVariables>(RemoveAttendeesFrom3dPartyCalendarsDocument, options);
      }
export function useRemoveAttendeesFrom3dPartyCalendarsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RemoveAttendeesFrom3dPartyCalendarsQuery, RemoveAttendeesFrom3dPartyCalendarsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RemoveAttendeesFrom3dPartyCalendarsQuery, RemoveAttendeesFrom3dPartyCalendarsQueryVariables>(RemoveAttendeesFrom3dPartyCalendarsDocument, options);
        }
export type RemoveAttendeesFrom3dPartyCalendarsQueryHookResult = ReturnType<typeof useRemoveAttendeesFrom3dPartyCalendarsQuery>;
export type RemoveAttendeesFrom3dPartyCalendarsLazyQueryHookResult = ReturnType<typeof useRemoveAttendeesFrom3dPartyCalendarsLazyQuery>;
export type RemoveAttendeesFrom3dPartyCalendarsQueryResult = Apollo.QueryResult<RemoveAttendeesFrom3dPartyCalendarsQuery, RemoveAttendeesFrom3dPartyCalendarsQueryVariables>;
export const RemoveAttendeesFrom3dPartyCalendarsEventSeriesDocument = gql`
    query removeAttendeesFrom3dPartyCalendarsEventSeries($eventId: PositiveInt!, $emails: [String!]!) {
  admin {
    recurringEvent(id: $eventId) {
      removeAttendeesFrom3dPartyCalendars(emails: $emails)
    }
  }
}
    `;

/**
 * __useRemoveAttendeesFrom3dPartyCalendarsEventSeriesQuery__
 *
 * To run a query within a React component, call `useRemoveAttendeesFrom3dPartyCalendarsEventSeriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRemoveAttendeesFrom3dPartyCalendarsEventSeriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRemoveAttendeesFrom3dPartyCalendarsEventSeriesQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      emails: // value for 'emails'
 *   },
 * });
 */
export function useRemoveAttendeesFrom3dPartyCalendarsEventSeriesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RemoveAttendeesFrom3dPartyCalendarsEventSeriesQuery, RemoveAttendeesFrom3dPartyCalendarsEventSeriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RemoveAttendeesFrom3dPartyCalendarsEventSeriesQuery, RemoveAttendeesFrom3dPartyCalendarsEventSeriesQueryVariables>(RemoveAttendeesFrom3dPartyCalendarsEventSeriesDocument, options);
      }
export function useRemoveAttendeesFrom3dPartyCalendarsEventSeriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RemoveAttendeesFrom3dPartyCalendarsEventSeriesQuery, RemoveAttendeesFrom3dPartyCalendarsEventSeriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RemoveAttendeesFrom3dPartyCalendarsEventSeriesQuery, RemoveAttendeesFrom3dPartyCalendarsEventSeriesQueryVariables>(RemoveAttendeesFrom3dPartyCalendarsEventSeriesDocument, options);
        }
export type RemoveAttendeesFrom3dPartyCalendarsEventSeriesQueryHookResult = ReturnType<typeof useRemoveAttendeesFrom3dPartyCalendarsEventSeriesQuery>;
export type RemoveAttendeesFrom3dPartyCalendarsEventSeriesLazyQueryHookResult = ReturnType<typeof useRemoveAttendeesFrom3dPartyCalendarsEventSeriesLazyQuery>;
export type RemoveAttendeesFrom3dPartyCalendarsEventSeriesQueryResult = Apollo.QueryResult<RemoveAttendeesFrom3dPartyCalendarsEventSeriesQuery, RemoveAttendeesFrom3dPartyCalendarsEventSeriesQueryVariables>;